/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;

      const initialLocation = $( '.special-filter.order-1' ).attr( 'data-location' );
      filterSpecials( initialLocation );

      $( '.special-filter' ).on( 'click', function() {
        filterSpecials( $( this ).attr( 'data-location' ) );
      } );

      function filterSpecials( location ) {
        $( '.special-filter:not([data-location*="' + location + '"])' ).removeClass( 'is-active' );
        $( '.special-filter[data-location*="' + location + '"]' ).addClass( 'is-active' );

        $( '.special-card__wrapper:not([data-locations*="' + location + '"])' ).removeClass( 'is-active' );
        $( '.special-card__wrapper[data-locations*="' + location + '"]' ).addClass( 'is-active' );

        $( '.category-group' ).each( function() {
          if ( $( this ).find( '.special-card__wrapper.is-active' ).length ) {
            $( this ).show();
          } else {
            $( this ).hide();
          }
        } );
      }
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'specials', COMPONENT );
} )( app );
